export default "__VITE_ASSET__y71IuoG3__"